import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid-container"
}
const _hoisted_2 = { class: "ghost-name" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "solved-overlay"
}
const _hoisted_5 = {
  class: "sale-flash badge bg-color rounded-0 fw-normal p-2",
  style: {"left":"0"}
}
const _hoisted_6 = {
  key: 1,
  class: "solved-overlay"
}
const _hoisted_7 = {
  key: 2,
  class: "solved-overlay"
}
const _hoisted_8 = { class: "crossword-grid mx-auto" }
const _hoisted_9 = ["id", "onUpdate:modelValue"]
const _hoisted_10 = { class: "clue-number" }
const _hoisted_11 = {
  key: 1,
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.filteredMessages && _ctx.filteredMessages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message.actionId,
              class: "grid-item"
            }, [
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("a", {
                  href: `/user/${message.userId}`
                }, _toDisplayString(message.username), 9, _hoisted_3)
              ]),
              (_ctx.isSolved(message) && !_ctx.isRevealed(message))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[0] || (_cache[0] = _createTextVNode(" Solved")),
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.gameTime(message)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isWaiting(message))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[2] || (_cache[2] = [
                    _createElementVNode("div", {
                      class: "sale-flash badge bg-color rounded-0 fw-normal p-2",
                      style: {"left":"0"}
                    }, " Waiting... ", -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.isRevealed(message))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[3] || (_cache[3] = [
                    _createElementVNode("div", {
                      class: "sale-flash badge bg-color rounded-0 fw-normal p-2",
                      style: {"left":"0"}
                    }, " Revealed ", -1)
                  ])))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.y, (y) => {
                      return (_openBlock(), _createElementBlock("tr", { key: y }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossword.x, (x) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: x,
                            class: "crossword-grid-cell",
                            style: _normalizeStyle(_ctx.cellStyle)
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              id: _ctx.getCellId(x - 1, y - 1),
                              "onUpdate:modelValue": ($event: any) => ((_ctx.grid[x - 1][y - 1]) = $event),
                              class: _normalizeClass({
                    'black-cell': _ctx.isBlackCell(x - 1, y - 1),
                    'highlighted-cell': _ctx.shouldGhostHighlightCell(message, x - 1, y - 1),
                  }),
                              autocomplete: "off",
                              disabled: "",
                              readonly: ""
                            }, null, 10, _hoisted_9), [
                              [_vModelText, _ctx.grid[x - 1][y - 1]]
                            ]),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getCellNumber(x - 1, y - 1)), 1)
                          ], 4))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.filteredMessages.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[4] || (_cache[4] = [
          _createStaticVNode("<div class=\"feature-box fbox-center fbox-bg fbox-plain mb-4\" data-v-0e16583b><div class=\"fbox-icon bg-color-2\" data-v-0e16583b><div class=\"css3-spinner\" style=\"--cnvs-loader-color:var(--cnvs-themecolor);padding-top:10px;padding-bottom:10px;\" data-v-0e16583b><div class=\"css3-spinner-grid-pulse\" data-v-0e16583b><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div><div data-v-0e16583b></div></div></div></div><div class=\"fbox-content\" data-v-0e16583b><h3 data-v-0e16583b>Waiting for other players to join</h3></div></div>", 1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}